export const RTL_LANGUAGES = ['ar'];
